import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Popover, Button, Typography } from '@material-ui/core';
import { Event, KeyboardArrowDown } from '@material-ui/icons';
import { CircularProgress } from "@material-ui/core";
import moment from 'moment';

export function CalendarPick({ start, end, onChange, onClose, isCalendarLoading }) {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		onClose()
		setAnchorEl(null);
	};
	
	const handleSelect = ({ selection: { startDate, endDate } }) => {
		onChange(startDate.toDateString(), endDate.toDateString());
	};
	const closeDatePicker = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<Button style={{ height: 52 }} variant='outlined' onClick={handleClick}>
				<Event />
				{isCalendarLoading ? <CircularProgress style={{ height: '20px', width: '20px', margin: '0 55px' }} />
					: <Typography variant='body1' style={{ marginLeft: 4, marginRight: 12 }}>
						{moment.utc(start).format('MM/DD/YYYY')} - {moment.utc(end).format('MM/DD/YYYY')}
					</Typography>}
				<KeyboardArrowDown />
			</Button>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={closeDatePicker}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<DateRangePicker
					ranges={[
						{
							startDate: new Date(start) || new Date(),
							endDate: new Date(end) || new Date(),
							key: 'selection',
							showDateDisplay: false,
							color: '#fd6256',
						},
					]}
					moveRangeOnFirstSelection={false}
					onChange={handleSelect}
				/>
				<Button variant="outlined" onClick={handleClose} style={{ display: 'block', marginLeft: '43%', marginBottom: '5px' }}>
					ok
				</Button>
			</Popover>
		</>
	);
}
